import { initScrollToTop } from './initScrollToTop';

export function initFilterCardFeatures() {
    // VARS
    const mainContent = document.querySelectorAll('[data-main]');
    const featureItems = document.querySelectorAll('[data-btn-feature]');
    const activeClass = '--active-item';

    // LISTENERS
    featureItems.forEach((item) => {
        item.addEventListener('click', handleOnClick, false);
    });

    // HANDLER
    function handleOnClick() {
        const target = this.dataset.btnFeature;

        filterContent(target, this);
        toggleToClassActive(this);
    }

    // FUNCTION
    function filterContent(target, itemButton) {
        mainContent.forEach((main) => {
            if (main.dataset.main === target) {
                main.style.display = 'block';
            } else {
                main.style.display = 'none';
            }
        });
        scrollToTop();
    }

    function scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }

    function toggleToClassActive(itemButton) {
        featureItems.forEach((button) => {
            button.classList.remove(activeClass);
        });

        itemButton.classList.add(activeClass);
    }
}
